import React, { useEffect, useState, useRef, forwardRef } from 'react'
import { Controller } from 'react-hook-form'
import { Button, Modal, Input, Toast } from '@ow/comps'
import { orgTreeData } from '@vt/apis/lib-ex/v2/orgs'
import { getRolesMoreData, addRole, updateRole } from '@vt/apis/lib-ex/v2/role'
import useForm from './use-form'
import Tree from '../../tree/tree'

// 操作（编辑、添加）角色弹窗
const OperationRole = function (
  { appId, edit, rolesMutate, closeModal, currentRole = {} },
  ref
) {
  const formRef = useRef(null)
  const [treeData, setTreeData] = useState([])
  const [checkedKeys, setCheckedKeys] = useState([])
  const { orgsData } = orgTreeData(appId)
  const {
    control,
    formState: { errors },
    setValue,
    clearErrors,
    reset,
  } = useForm(
    {
      currentRole,
    },
    formRef
  )
  console.log({ currentRole })
  useEffect(() => {
    if (orgsData) {
      setTreeData(orgsData)
      // 编辑回显树
      // 这里是做什么啊
      if (edit && currentRole && currentRole.id) {
        getRolesMoreData(appId, currentRole.id).then((res) => {
          setCheckedKeys(res.orgIds.map(String))
        })
      }
    }
  }, [orgsData, currentRole])
  const updateCheckedOrgs = (info) => {
    setCheckedKeys(info)
    clearErrors('orgIds')
    setValue('orgIds', info)
  }

  const onSubmit = () => {
    const data = formRef.current.getValues()
    formRef.current.trigger().then((tr) => {
      console.log('user->>', tr, errors, data)
      if (tr) {
        if (edit) {
          console.log()
          updateRole(appId, {
            ...data,
            orgIds: checkedKeys,
            id: currentRole.id,
          })
            .then(() => {
              Toast.success({
                title: '通知',
                description: '操作成功！',
              })
              rolesMutate()
              if (closeModal) {
                closeModal()
              }
            })
            .catch((error) => {
              // if (error.response.data.message) {
              Toast.error({
                title: '操作失败',
                description: error.response.data.message,
              })
              // }
            })
          return
        }
        addRole(appId, { ...data, orgIds: checkedKeys })
          .then(() => {
            Toast.success({
              title: '通知',
              description: '操作成功！',
            })
            // 重置表单
            reset()
            setCheckedKeys([])

            rolesMutate()
            if (closeModal) {
              closeModal()
            }
          })
          .catch((error) => {
            if (error.response.data.message) {
              Toast.error({
                title: '操作失败',
                description: error.response.data.message,
              })
            }
          })
      }
    })
  }

  return (
    <Modal
      ref={ref}
      title={`${edit ? '编辑' : '添加'}角色`}
      size="md"
      // eslint-disable-next-line react/no-unstable-nested-components
      footer={() => (
        <>
          <Button
            type="primary"
            opacityType="sm"
            style={{ marginRight: '10px' }}
            onClick={closeModal}
          >
            取消
          </Button>
          <Button type="primary" onClick={onSubmit}>
            确定
          </Button>
        </>
      )}
    >
      <form>
        <div className="p-5 gap-4 gap-y-3 flex flex-col">
          <div className="flex flex-col">
            <label className="mr-5">
              <b>
                <span className="text-red-500">*</span>
              </b>
              &nbsp;角色名称
            </label>
            <Controller
              render={({ field }) => {
                return (
                  <Input
                    {...field}
                    placeholder="请输入"
                    defaultValue={currentRole.name}
                    className="input form-input w-full border flex-1 mt-2"
                    onChange={(e) => {
                      clearErrors('name')
                      field.onChange(e)
                    }}
                  />
                )
              }}
              name="name"
              rules={{ required: true, maxLength: 40 }}
              control={control}
              defaultValue={currentRole.name}
            />
            {errors.name && errors.name.type === 'required' && (
              <p className="text-red-500 text-sm mt-2">请输入角色名称</p>
            )}
            {errors.name && errors.name.type === 'maxLength' && (
              <p className="text-red-500 text-sm mt-1">
                角色名称不能超过40个字符
              </p>
            )}
          </div>
          <div className="flex flex-col">
            <label className="mr-5">
              <b>
                <span className="text-red-500">*</span>
              </b>
              &nbsp;角色标记
            </label>
            <Controller
              render={({ field }) => {
                return (
                  <Input
                    {...field}
                    placeholder="请输入"
                    defaultValue={currentRole.mark}
                    className="input form-input w-full border flex-1 mt-2"
                    onChange={(e) => {
                      clearErrors('mark')
                      field.onChange(e)
                    }}
                  />
                )
              }}
              name="mark"
              rules={{ required: true, maxLength: 40 }}
              control={control}
              defaultValue={currentRole.mark}
            />
            {errors.name && errors.name.type === 'required' && (
              <p className="text-red-500 text-sm mt-2">请输入角色标记</p>
            )}
            {errors.name && errors.name.type === 'maxLength' && (
              <p className="text-red-500 text-sm mt-1">
                角色标记不能超过40个字符
              </p>
            )}
          </div>
          <div className="flex flex-col">
            <label className="mr-5">
              <b>
                <span className="text-red-500">*</span>
              </b>
              &nbsp;所属组织
            </label>
            <div className="flex-1 h-56 overflow-y-auto" />
            <Controller
              render={({ field }) => {
                return (
                  <Tree
                    datas={treeData}
                    checkable
                    updateCheckedKeys={(e) => {
                      field.onChange(e)
                      updateCheckedOrgs(e)
                    }}
                    selectedKeys={checkedKeys}
                    checkStrictly
                    titleLen={18}
                  />
                )
              }}
              name="orgIds"
              // rules={{ required: true }}
              control={control}
              defaultValue={checkedKeys}
            />
            {errors.orgIds && errors.orgIds.type === 'required' && (
              <p className="text-red-500 text-sm mt-2">请选择组织</p>
            )}
          </div>
        </div>
      </form>
    </Modal>
  )
}

export default forwardRef(OperationRole)
